import { render } from "./LandingPage.vue?vue&type=template&id=51ff19b8&scoped=true"
const script = {}

import "./LandingPage.vue?vue&type=style&index=0&id=51ff19b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ff19b8"]])

export default __exports__